
import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers/reducers';
import { initParams } from './reducers/params';
import { initData } from './reducers/data';
import App from './components/App/App';
import './index.css';

// the id of the div to render too
let appId = 'targetfloorapp';


// optionally set param from window.fundListingsParams
initParams.ticker = window.location.href.split('/').pop().split('?')[0].toUpperCase();

if (!initParams.ticker) {
  initParams.ticker = 'GTR';
}

//initParams.ticker = 'USFL';

// optionally load attributes from script tag
function getSyncScriptParams() {
  const scripts = document.getElementsByTagName('script');
  const lastScript = scripts[scripts.length - 1];
  const scriptName = lastScript;
  if (scriptName.getAttribute('appId')) {
    appId = scriptName.getAttribute('appId');
  }
}
getSyncScriptParams();

// render
ReactDOM.render(
  <Provider
    store={createStore(
      reducers,
      { params: initParams, data: initData },
      applyMiddleware(thunk),
    )}
  >
    <App />
  </Provider>,
  document.getElementById(appId),
);



// WEBPACK FOOTER //
// ./src/index.js